module.exports = __WEBPACK_EXTERNAL_MODULE_43__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","http"],"commonjs":"@angular/http","commonjs2":"@angular/http","amd":"@angular/http"}
// module id = 43
// module chunks = 0 1